import store from '@/store'
import axios from 'axios'
import { Toast } from 'vant'

let loadingCount = 0

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/',
  timeout: 30000
})

function beginLoading (config) {
  if (config.showLoading === false) return
  config.__globalLoading = true
  loadingCount += 1
  if (loadingCount === 1) {
    Toast.loading({ message: '加载中...', forbidClick: true, duration: 0, loadingType: 'spinner' })
  }
}

function endLoading (config) {
  if (!config || !config.__globalLoading) return
  loadingCount = Math.max(0, loadingCount - 1)
  config.__globalLoading = false
  if (loadingCount === 0) Toast.clear()
}

function goLogin () {
  store.commit('removeUserInfo')
  const backUrl = window.location.pathname + window.location.search
  window.location.href = '/login?backUrl=' + encodeURIComponent(backUrl)
}

instance.interceptors.request.use(config => {
  beginLoading(config)
  const token = store.getters.token
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
}, error => {
  endLoading(error.config)
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  endLoading(response.config)
  if (response.config.responseType === 'blob') {
    const type = response.headers['content-type'] || ''
    if (!type.includes('application/json')) return response
    return response.data.text().then(text => {
      const data = JSON.parse(text)
      const message = data.msg || '下载失败，请稍后重试'
      Toast.fail(message)
      if (data.data === 401) goLogin()
      return Promise.reject(new Error(message))
    })
  }

  const data = response.data || {}
  if (data.code === 0) return data

  const message = data.msg || '操作失败，请稍后重试'
  if (data.data === 401 || response.status === 401) {
    Toast.fail('登录已过期，请重新登录')
    goLogin()
  } else if (!response.config.silentError) {
    Toast.fail(message)
  }
  return Promise.reject(new Error(message))
}, error => {
  endLoading(error.config)
  const status = error.response && error.response.status
  const responseData = error.response && error.response.data
  const message = responseData && responseData.msg
    ? responseData.msg
    : (error.code === 'ECONNABORTED' ? '请求超时，请稍后重试' : '网络连接失败，请检查网络')
  if (status === 401) {
    Toast.fail('登录已过期，请重新登录')
    goLogin()
  } else if (!(error.config && error.config.silentError)) {
    Toast.fail(message)
  }
  return Promise.reject(error)
})

export default instance
